import { Stack, Typography } from '@mui/material';
import { ValueInput } from '@utils/formattersV2';
import { ComponentProps } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { ChartTitle } from './ChartTitle';
import { ConfidenceLevel } from '@features/campaigns/components/ConfidenceLevel';
import {
  RslWaterfallChartProps,
  rslWaterfallChartOptions,
} from '../../configuration/waterfallChartOptions';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

type WaterfallChartWithHeaderProps = ComponentProps<typeof ChartTitle> & {
  chartProps: RslWaterfallChartProps;
  value: number;
  valueFormatter: (value: ValueInput) => string;
  confidenceLevel: ValueInput;
};

export const WaterfallChartWithHeader = (
  props: WaterfallChartWithHeaderProps
) => {
  return (
    <Stack
      direction="column"
      gap="1rem"
      alignItems="center"
      height="100%"
      border={1}
      borderColor={unifiedPlatformColorPalette.lightGrey300}
      borderRadius="4px"
    >
      <ChartTitle title={props.title} />
      <Stack direction="row" gap="0.5rem" alignItems="center">
        <Typography fontSize="h4.fontSize" fontWeight="bold">
          {props.valueFormatter(props.value)}
        </Typography>
        <ConfidenceLevel value={props.confidenceLevel} lift={props.value} />
      </Stack>
      <HighchartsReact
        highcharts={Highcharts}
        options={rslWaterfallChartOptions(props.chartProps)}
        containerProps={{
          ['data-testid']: 'waterfall-chart',
          style: { width: '100%' },
        }}
      />
    </Stack>
  );
};
